import React from 'react';
import { Upload, Zap, Lightbulb, SearchCheck } from "lucide-react";
import { DEFAULT_PLANS, DEFAULT_SYS_CONFIG } from "../../config/constants";

const SmartNav = ({ onNav, activeTab, quizCount = 0, conceptCount = 0, userData, plansMap, sysConfig }) => {
  const commonClass = "flex-1 flex flex-col items-center justify-center p-2 rounded-xl border border-slate-100 shadow-sm transition-all hover:bg-slate-50 hover:scale-105 active:scale-95 cursor-pointer relative z-50 min-h-[70px]";
  const isHome = activeTab === 'upload'; 

  const getDailyStatus = (type) => {
    if (!userData || !plansMap) return { text: "...", color: "text-slate-300" };
    const planId = (userData.planId || 'A').toUpperCase();
    const plan = plansMap[planId] || plansMap['A'] || DEFAULT_PLANS['A'];
    const config = sysConfig || DEFAULT_SYS_CONFIG;

    let limit = 0;
    let cost = 0;
    let used = 0;

    if (type === 'question') {
        limit = Number(plan.dailyLimit);
        cost = Number(config.pointCostQuestion);
        used = userData.todaySolved || 0;
    } else if (type === 'quiz') {
        limit = Number(plan.similarLimit);
        cost = Number(config.pointCostQuiz);
        used = userData.todayQuizzes || 0;
    } else if (type === 'concept') {
        limit = Number(plan.conceptLimit);
        cost = Number(config.pointCostConcept);
        used = userData.todayConcepts || 0;
    }

    if (limit === -1) return { text: "無限暢用", color: "bg-amber-100 text-amber-700 border-amber-200" };
    const remaining = Math.max(0, limit - used);
    if (remaining > 0) {
        return { text: `今日剩 ${remaining}`, color: "bg-emerald-100 text-emerald-700 border-emerald-200" };
    } else {
        return { text: `扣 ${cost} 點`, color: "bg-rose-100 text-rose-700 border-rose-200" };
    }
  };

  const questionDaily = getDailyStatus('question');
  const quizDaily = getDailyStatus('quiz');
  const conceptDaily = getDailyStatus('concept');

  return (
    <div className="grid grid-cols-4 gap-2 md:gap-4 mb-2">
      <div onClick={() => onNav('upload')} className={`${commonClass} ${activeTab === 'upload' ? "ring-2 ring-orange-200 bg-orange-50" : ""}`}>
        <div className="w-8 h-8 rounded-lg bg-orange-100 flex items-center justify-center text-slate-600 mb-1"><Upload size={16} /></div>
        <div className="flex flex-col items-center">
            <span className="font-bold text-slate-700 text-[10px] md:text-xs">上傳題目</span>
            <span className="text-[9px] text-slate-400 transform scale-90">打字 + 拍題</span>
        </div>
      </div>

      <div onClick={() => onNav('analysis')} className={`${commonClass} ${activeTab === 'analysis' ? "ring-2 ring-violet-200 bg-violet-50" : ""}`}>
        <div className="w-8 h-8 rounded-lg bg-violet-100 flex items-center justify-center text-slate-600 mb-1"><Zap size={16} /></div>
        <div className="flex flex-col items-center w-full">
            <span className="font-bold text-slate-700 text-[10px] md:text-xs">AI 解析</span>
            <span className="text-[9px] text-slate-400 transform scale-90">簡易 + 詳解</span>
            {questionDaily && (
                <span className={`text-[8px] px-1.5 py-0.5 rounded-full border mt-0.5 font-bold ${questionDaily.color}`}>
                    {questionDaily.text}
                </span>
            )}
        </div>
      </div>

      <div onClick={() => onNav('concept')} className={`${commonClass} ${activeTab === 'concept' ? "ring-2 ring-yellow-200 bg-yellow-50" : ""}`}>
        <div className="w-8 h-8 rounded-lg bg-sky-100 flex items-center justify-center text-slate-600 mb-1"><Lightbulb size={16} /></div>
        <div className="flex flex-col items-center w-full">
            <span className="font-bold text-slate-700 text-[10px] md:text-xs text-center">重點整理</span>
            <span className="text-[9px] text-slate-500 font-medium transform scale-90">
                {isHome ? "核心 + 觀念" : `已用 (${conceptCount}/1)`}
            </span>
            {conceptDaily && (
                <span className={`text-[8px] px-1.5 py-0.5 rounded-full border mt-0.5 font-bold ${conceptDaily.color}`}>
                    {conceptDaily.text}
                </span>
            )}
        </div>
      </div>

      <div onClick={() => onNav('quiz')} className={`${commonClass} ${activeTab === 'quiz' ? "ring-2 ring-blue-200 bg-blue-50" : ""}`}>
        <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center text-slate-600 mb-1"><SearchCheck size={16} /></div>
        <div className="flex flex-col items-center w-full">
            <span className="font-bold text-slate-700 text-[10px] md:text-xs text-center">舉一反三</span>
            <span className="text-[9px] text-slate-500 font-medium transform scale-90">
                {isHome ? "類題 + 演練" : `已用 (${quizCount}/3)`}
            </span>
            {quizDaily && (
                <span className={`text-[8px] px-1.5 py-0.5 rounded-full border mt-0.5 font-bold ${quizDaily.color}`}>
                    {quizDaily.text}
                </span>
            )}
        </div>
      </div>
    </div>
  );
};

export default SmartNav;
